import ProductoList from '../components/productos/ProductoList';

export default function ProductosPage() {
  return <ProductoList />;
}